import { Injectable } from '@angular/core';
import { CanActivateChild } from '@angular/router';

import { AuthGuard } from '../../core/services/auth/auth-guard.service';
import { AuthService } from '../../core/services/auth/auth.service';
import { UsuarioPerfil, usuarioPerfilAdministrador, usuarioPerfilAtendente, usuarioPerfilGerente, usuarioPerfilPCP, usuarioPerfilRepresentante } from '../usuario/usuario-perfil';


/** Acessos permitidos para as cotações */
export const acessosCotacao: UsuarioPerfil[] = [usuarioPerfilAdministrador, usuarioPerfilRepresentante, usuarioPerfilGerente, usuarioPerfilAtendente, usuarioPerfilPCP];

/** Acessos permitidos para as cotações na empresa Rafitec */
const acessosCotacaoRafitec: UsuarioPerfil[] = [usuarioPerfilAdministrador, usuarioPerfilAtendente];

/** Retornar os acessos permitidos para as cotações */
export function getAcessosCotacao(authService: AuthService): UsuarioPerfil[] {
    // Rafitec
    if (authService.isRafitec()) {
        return acessosCotacaoRafitec;
    }
    return acessosCotacao;
}

@Injectable()
export class CanActivateCotacao implements CanActivateChild {

    constructor(private authGuard: AuthGuard) { }

    canActivateChild(): boolean {
        return this.authGuard.canActivateAcesso(acessosCotacao);
    }
}
